import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=cea453c6&"
import script from "./mainInfo.vue?vue&type=script&lang=js&"
export * from "./mainInfo.vue?vue&type=script&lang=js&"
import style0 from "./mainInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports